import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-109c213a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view w-100 h-100" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title m-auto" }
const _hoisted_4 = { class: "button-container" }
const _hoisted_5 = { class: "button-group" }
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = { class: "button-group" }
const _hoisted_8 = {
  disabled: "",
  class: "btn-round btn-dark-blue",
  to: { name: 'select-price-type' }
}
const _hoisted_9 = {
  disabled: "",
  class: "btn-round btn-dark-blue",
  to: { name: 'select-price-type' }
}
const _hoisted_10 = { class: "link mx-auto" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-info mx-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("cashier.title.select-price-type")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceTypes, (price) => {
            return (_openBlock(), _createElementBlock("button", {
              key: price.id,
              disabled: !_ctx.isPriceTypeAvailable(price.id),
              onClick: ($event: any) => (_ctx.selectPriceType(price.id)),
              class: "btn-round btn-dark-blue col-6"
            }, _toDisplayString(_ctx.getPriceTypeName(price, _ctx.currentLanguageId)), 9, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.$t("fit-tourist")), 1),
          _createElementVNode("button", _hoisted_9, _toDisplayString(_ctx.$t("group-tourist")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createTextVNode(" " + _toDisplayString(_ctx.t("cashier.system-alerts.feedback")), 1)
      ])
    ])
  ]))
}